// Mock Dhaba/Restaurant Data
// This will be replaced with API calls in production

export const dhabas = [
  {
    id: '1',
    name: 'Punjab Da Dhaba',
    image: 'https://images.unsplash.com/photo-1708517194326-6077b788f04b?w=400',
    rating: 4.5,
    reviewCount: 342,
    cuisine: 'North Indian • Punjabi',
    distance: '2.3 km',
    time: '15 min',
    isOpen: true,
    price: '₹₹',
    address: 'NH-48, Near Toll Plaza, Manesar',
    tags: ['Pure Veg', 'Family Friendly', 'Parking'],
    coordinates: { lat: 28.4650, lng: 77.0320 },
  },
  {
    id: '2',
    name: 'Highway King Restaurant',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400',
    rating: 4.2,
    reviewCount: 518,
    cuisine: 'Multi-cuisine • Fast Food',
    distance: '5.1 km',
    time: '20 min',
    isOpen: true,
    price: '₹₹₹',
    address: 'Expressway Service Road, Jaipur Highway',
    tags: ['AC Dining', 'Parking', 'Card Accepted'],
    coordinates: { lat: 28.4580, lng: 77.0200 },
  },
  {
    id: '3',
    name: 'Sher-e-Punjab',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400',
    rating: 4.7,
    reviewCount: 892,
    cuisine: 'North Indian • Mughlai',
    distance: '8.4 km',
    time: '25 min',
    isOpen: true,
    price: '₹₹',
    address: 'GT Karnal Road, Sonipat',
    tags: ['Non-Veg', 'Bestseller', 'Clean Washrooms'],
    coordinates: { lat: 28.4700, lng: 77.0350 },
  },
  {
    id: '4',
    name: 'Amrik Sukhdev Dhaba',
    image: 'https://images.unsplash.com/photo-1552566626-52f8b828add9?w=400',
    rating: 4.8,
    reviewCount: 2341,
    cuisine: 'Punjabi • Parathas',
    distance: '12.0 km',
    time: '30 min',
    isOpen: true,
    price: '₹',
    address: 'Murthal, NH-1, Sonipat',
    tags: ['Legendary', 'Open 24x7', 'Famous Parathas'],
    coordinates: { lat: 28.4550, lng: 77.0150 },
  },
];

// Alias for backward compatibility
export const restaurants = dhabas;
